import { service } from '@maia/quotation';
import { useMutation } from '@tanstack/react-query';

type Params = Parameters<typeof service.sendMail>[0];

export function useSendMail(
  onSuccess: (data: unknown) => void,
  onError: () => void,
) {
  return useMutation({
    mutationFn: (params: Params) => service.sendMail(params),
    onSuccess,
    onError,
  });
}
